import { render } from "./PharmaPipelinesView.vue?vue&type=template&id=58f3e9d2&scoped=true"
import script from "./PharmaPipelinesView.vue?vue&type=script&lang=js"
export * from "./PharmaPipelinesView.vue?vue&type=script&lang=js"

import "./PharmaPipelinesView.vue?vue&type=style&index=0&id=58f3e9d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f3e9d2"]])

export default __exports__